import { downloadVehicleZipImages } from "api/stockApi"
import { useState } from "react"
import { Button } from "reactstrap"

export default function ImageZipDownloader({
  vehicleId,
  btnText = "Download all images ZIP",
  loadingText = "Downloading images...",
}) {
  const [isLoading, setIsLoading] = useState(false)

  const handleDownload = async () => {
    if (!vehicleId) return
    setIsLoading(true)

    try {
      const response = await downloadVehicleZipImages(vehicleId, {
        include_auction_sheet: true,
      })

      const blob = new Blob([response.data])
      const url = window.URL.createObjectURL(blob)

      const disposition = response.headers["content-disposition"]
      let filename = `${vehicleId}-images.zip`

      if (disposition) {
        const match = disposition.match(/filename="?(.+)"?/)
        if (match?.[1]) filename = match[1]
      }

      const link = document.createElement("a")
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()

      link.remove()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error("Download failed:", error)
      alert("Failed to download images.")
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Button
      onClick={handleDownload}
      disabled={isLoading || !vehicleId}
      color="primary"
      className="mb-2 d-flex align-items-center gap-2 btn-soft-primary"
    >
      <i className="fas fa-file-archive"></i> {/* ZIP icon */}
      {isLoading ? (
        loadingText ? (
          <small>{loadingText}</small>
        ) : (
          ""
        )
      ) : btnText ? (
        <small>{btnText}</small>
      ) : (
        ""
      )}
    </Button>
  )
}
